import axios from 'axios';
export default {
    debounce({ dispatch }, { action, timeout, payload }) {
        if (window._debouncedAction)
            window.clearTimeout(window._debouncedAction);
        window._debouncedAction = window.setTimeout(function() {
            dispatch(action, payload);
        }, timeout);
    },
    async getList({ commit, getters }) {
        commit('changeLoading', { item: 'list', isLoading: true });
        try {
            await axios
                .get(`${getters.apiUrl}`)
                .then(({ data }) => {
                    commit('updateList', data);
                })
                .then(() => {
                    commit('changeLoading', { item: 'list', isLoading: false });
                });
        } catch (err) {
            commit('changeLoading', { item: 'list', isLoading: false });
            this.status = 'error';
            this.publicationsList = [];
        }
    },
    getMetaFields({ commit, state }) {
        commit('changeLoading', { item: 'filters', isLoading: true });
        const requests = state.filters.map((filter, index) => {
            if (filter.url.length == 0) return;
            return axios
                .get(process.env.VUE_APP_API_ROOT + filter.url)
                .then(({ data }) => {
                    commit('updateMetaList', {
                        index,
                        data: data.results,
                        name: filter.name,
                    });
                    return data;
                })
                .catch((err) => {
                    return err;
                });
        });

        return new Promise((resolve, reject) => {
            Promise.all(requests)
                .then(({ data }) => {
                    resolve({ data });
                    commit('changeLoading', {
                        item: 'filters',
                        isLoading: false,
                    });
                })
                .catch(() => {
                    reject('error');
                });
        });
    },
    changePage: ({ commit }, payload) => {
        return new Promise((resolve) => {
            commit('changePage', payload);
            resolve();
        });
    },
    updateFilterOptions: ({ commit }) => {
        commit('updateFilterOptions');
    },
    toggleListFilterItem: ({ commit }, data) => {
        commit('toggleListFilterItem', data);
    },
    updateFilterValue: ({ commit, dispatch }, data) => {
        commit('changeLoading', { item: 'list', isLoading: true });
        switch (data.type) {
            case 'list': {
                if (data.clearAll) {
                    commit('clearListFilter', data);
                } else {
                    commit('toggleListFilterItem', data);
                }
                break;
            }

            case 'search': {
                if (data.clear) {
                    data.value = '';
                    commit('updateSearchQuery', { value: '' });
                    commit('updateFilterValue', data);
                } else {
                    commit('updateFilterValue', data);
                }

                break;
            }

            default: {
                if (data.clear) {
                    data.value = '';
                    commit('updateFilterValue', data);
                } else {
                    commit('updateFilterValue', data);
                }
            }
        }

        // Debounce a filtered list update in case other filters are in there
        dispatch('debounce', {
            action: 'getList',
            timeout: 500,
        });
    },
    updateSearchQuery: ({ commit }, { value }) => {
        commit('updateSearchQuery', { value });
    },
    changeFilterState: ({ commit }, { index, action }) => {
        switch (action) {
            case 'close': {
                commit('closeFilter', index);
                break;
            }
            default: {
                commit('toggleFilterState', index);
                break;
            }
        }
    },
};
